import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TopicService } from '../topic.service';
import { CryptoService } from '../crypto.service';
import { CryptoView } from '../crypto-view';

@Component({
  selector: 'app-pigpen',
  templateUrl: './pigpen.component.html',
  styleUrls: ['../topic-style.css','./pigpen.component.css']
})
export class PigpenComponent extends CryptoView {

  
  @Input() current: string;
  @Input() modus: string;

  inputs: string[];

  constructor(topicService: TopicService, protected cryptoService: CryptoService) {
    super(topicService);
    this.inputs = new Array(26).fill("");
  }

  /** returns the mapping */
  getMapping() {
    return this.inputs.join(",");
  }

  /** sets the mapping */
  setmapping(mapping: string) {
    this.inputs = mapping.split(",").slice(0, 26);
  }

  /** resets the mapping */
  resetmapping(){
    this.setmapping(",,,,,,,,,,,,,,,,,,,,,,,,,");
  }

  /** does nothing */
  setHints(hints: string[]){
  }

  /** fills the mapping correctly */
  fillMapping(){
    for(let i of this.createArray(26)){
      this.inputs[i] = String.fromCharCode(i+65);
    }
  }

}
